import { render, staticRenderFns } from "./CompanyConfirmAlert.vue?vue&type=template&id=4e1062a1&scoped=true"
import script from "./CompanyConfirmAlert.vue?vue&type=script&lang=js"
export * from "./CompanyConfirmAlert.vue?vue&type=script&lang=js"
import style0 from "./CompanyConfirmAlert.vue?vue&type=style&index=0&id=4e1062a1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1062a1",
  null
  
)

export default component.exports